import React from "react";
import { PlusOutlined, CloseCircleFilled } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Popconfirm,
  Select,
  Space,
} from "antd";
import { BOM } from "../../../../services/definedMethod";
import appLabel from "../../../../config/appLabel";
import { taxGroupLabel } from "./taxGroup.config";

const AddingForm = (props) => {
  const { fields, remove, inputName, taxComponentOption, taxGroupDetail } =
    props;

  return (
    <>
      {fields.map(({ key, name, ...restField }) => (
        <Space
          key={key}
          style={{
            display: "flex",
            marginBottom: 8,
          }}
          align="baseline"
        >
          <Form.Item
            {...restField}
            name={[name, "taxComponentId"]}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(taxGroupLabel.taxComponent),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(taxGroupLabel.taxComponent)}
              style={{ width: "30vh" }}
              options={taxComponentOption}
              showSearch
            />
          </Form.Item>
          <Form.Item
            {...restField}
            name={[name, "startDate"]}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(taxGroupLabel.startDate),
              },
            ]}
          >
            <DatePicker
              style={{ width: "30vh" }}
              placeholder={BOM.handlePlaceholderMsg(taxGroupLabel.startDate)}
            />
          </Form.Item>
          {taxGroupDetail != "-" && (
            <Form.Item
              {...restField}
              name={[name, "endDate"]}
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(taxGroupLabel.startDate),
                },
              ]}
            >
              <DatePicker
                style={{ width: "30vh" }}
                placeholder={BOM.handlePlaceholderMsg(taxGroupLabel.startDate)}
              />
            </Form.Item>
          )}
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => remove(name)}
            okText="OK"
            cancelText="Cancel"
            okButtonProps={{
              style: {
                backgroundColor: "#92428B",
                color: "white",
                height: "15%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
            cancelButtonProps={{
              style: {
                height: "15%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
          >
            <CloseCircleFilled
              height={2}
              width={2}
              style={{
                color: "#92428B",
                fontSize: "25px",
                fontWeight: "bolder",
              }}
            />
          </Popconfirm>
        </Space>
      ))}
    </>
  );
};

const TaxComponentForm = (props) => {
  const { formName, taxComponentOption, taxGroupDetail } = props;
  const [form] = Form.useForm();

  return (
    <Form.List name={formName}>
      {(fields, { add, remove }) => (
        <>
          <Button
            onClick={() => add()}
            type="primary"
            icon={<PlusOutlined />}
            style={{
              backgroundColor: "#92428B",
              color: "white",
              width: "15vh",
              marginBottom: 20,
            }}
          >
            Add
          </Button>
          <AddingForm
            fields={fields}
            add={add}
            remove={remove}
            inputName={formName}
            taxComponentOption={taxComponentOption}
            taxGroupDetail={taxGroupDetail}
          />
        </>
      )}
    </Form.List>
  );
};

export default TaxComponentForm;
